import { render, staticRenderFns } from "./ExtendBooking.vue?vue&type=template&id=4e71b15a&"
import script from "./ExtendBooking.vue?vue&type=script&lang=js&"
export * from "./ExtendBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports